import { Component, OnInit, Input } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-phone-field[formGroup][propertyName]',
  templateUrl: './phone-field.component.html',
  styles: [],
  standalone: false,
})
export class PhoneFieldComponent extends BaseFormComponent implements OnInit{

  @Input() maxLength?: number;
  @Input() regular?: boolean;
  @Input() FIELD_SPACING: number;
  @Input() LABEL_SPACING: number;
  @Input() columns: number;

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    super.ngOnInit();
    if ( this.maxLength == null ) {
      this.maxLength = 12; // Default field length 10 and 2 periods as spacers
    }
  }

}
